import { render, staticRenderFns } from "./NewOwner.vue?vue&type=template&id=3ae9574d&scoped=true&"
import script from "./NewOwner.vue?vue&type=script&lang=js&"
export * from "./NewOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae9574d",
  null
  
)

export default component.exports